import { useTenantStack, useTenantStackChecker } from '@Hooks';
import { Button } from '@innovyze/stylovyze';
import { Grid } from '@mui/material';
import { SpinnerStatusIndicator } from '@Pages/EditSensor/SpinnerStatusIndicator';
import { useGlobalization } from '@Translations';
import React, { useMemo } from 'react';

type EdgeCreateCoreProps = {
	disabled: boolean;
};

export const EdgeCreateCore = (props: EdgeCreateCoreProps) => {
	const { disabled } = props;
	const { t } = useGlobalization();

	useTenantStackChecker();

	const {
		stackCheckRunning,
		tenantStackCreate,
		tenantStackCheck,
		stackExists,
		checkFailed,
	} = useTenantStack();

	const clickOnCreateTenantStackButtonHandler = () => {
		tenantStackCreate();
		tenantStackCheck();
	};

	const isButtonDisabled = useMemo(
		() => disabled || stackCheckRunning,
		[disabled, stackCheckRunning],
	);

	if (stackCheckRunning) {
		return (
			<Grid item>
				<SpinnerStatusIndicator text={'Loading...'} visible={true} />
			</Grid>
		);
	} else if (stackExists || checkFailed) {
		return null;
	}

	return (
		<Grid container spacing={1} direction="column">
			<Grid item>
				<Button
					data-cy="createTenantStackButton"
					color={'primary'}
					variant="contained"
					onClick={clickOnCreateTenantStackButtonHandler}
					disabled={isButtonDisabled}>
					{t('Start Installation')}
				</Button>
			</Grid>
		</Grid>
	);
};

export default EdgeCreateCore;
